import { app } from '@/firebase'
import { useUserStore } from '@/store/user'
import { logEvent } from 'firebase/analytics'
import { getAnalytics } from 'firebase/analytics'

export const AnalyticsEvents = {
  AUTH: {
    LOGIN: 'login',
    SIGNUP: 'signup',
    LOGOUT: 'logout',
    FORGOT_PASSWORD: 'forgot_password',
    UPDATE_PASSWORD: 'update_password',
    ACTIVATE_ACCOUNT: 'activate_account',
    REQUEST_ACTIVATION_TOKEN: 'request_activation_token',
  },
  PAGE: {
    VIEW: 'page_view',
  },
  DASHBOARD: {
    GROUP_TOTALIZER: 'buscou-dashboard-grupo',
    SENSOR_TOTALIZER: 'buscou-dashboard-sensor',
  },
  FARE_OPTIMIZER: {
    ANALYSIS: 'analisou-fatura',
    SAVE_INVOICE: 'salvou-fatura',
  },
  GROUP: {
    CREATED: 'criou-grupo',
    REMOVED: 'removeu-grupo',
    EDITED: 'editou-grupo',
  },
  SENSOR: {
    LIST: 'buscou-sensor',
  },
  ALARM: {
    CLASSIFICATION: {
      CREATED: 'criou-classificaçao',
      LIST: 'buscou-classificação',
      REMOVED: 'removeu-classificação',
    },
  },
  MAINTENANCE: {
    TYPE: {
      CREATED: 'criou-tipo-manutencao',
      LIST: 'buscou-tipos-manutencao',
    },
    COMMENT: {
      CREATED: 'criou-comentario',
      LIST: 'buscou-comentarios',
      EDITED: 'editou-comentario',
      DELETED: 'removeu-comentario',
    }
    ,
    CREATED: 'criou-manutencao',
    EDITED: 'editou-manutencao',
  },
}

export const logFirebaseAnalytics = (eventName: string, params?: object) => {
  const user = useUserStore().getCurrentUser
  const updatedParams = {
    ...params,
    user: user ? { id: user.id, name: user.name, email: user.email } : null,
  }

  if (import.meta.env.MODE === 'production') {
    const analytics = getAnalytics(app)
    logEvent(analytics, eventName, { log_params: JSON.stringify(updatedParams) })
  }
}
